import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdIndexService {
  private currentIndexSubject = new BehaviorSubject<number>(0);
  currentIndex$ = this.currentIndexSubject.asObservable();
  private currentIndexSubject1 = new BehaviorSubject<number>(0);
  currentIndex1$ = this.currentIndexSubject1.asObservable();

  getCurrentIndex(): number {
    return this.currentIndexSubject.value;
  }

  resetIndex(): void {
    this.currentIndexSubject.next(0);
  }

  incrementIndex(): void {
    this.currentIndexSubject.next(this.currentIndexSubject.value + 1);
  }

  getCurrentIndex1(): number {
    return this.currentIndexSubject.value;
  }

  resetIndex1(): void {
    this.currentIndexSubject.next(0);
  }

  incrementIndex1(): void {
    this.currentIndexSubject.next(this.currentIndexSubject.value + 1);
  }
}
